/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Seo_Endpoint_Q_FailoverInputs */

const en_seo_endpoint_q_failover = /** @type {(inputs: Seo_Endpoint_Q_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What happens if a source fails on the ${i?.name} ${i?.action} API?`)
};

const zh_hans1_seo_endpoint_q_failover = /** @type {(inputs: Seo_Endpoint_Q_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API 的某个数据源失败时会怎样？`)
};

const pt_br2_seo_endpoint_q_failover = /** @type {(inputs: Seo_Endpoint_Q_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O que acontece se uma fonte falhar no endpoint ${i?.action} da API para ${i?.name}?`)
};

const es_seo_endpoint_q_failover = /** @type {(inputs: Seo_Endpoint_Q_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Qué pasa si una fuente falla en el endpoint ${i?.action} de la API de ${i?.name}?`)
};

const fr_seo_endpoint_q_failover = /** @type {(inputs: Seo_Endpoint_Q_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Que se passe-t-il si une source échoue sur l’API ${i?.name} ${i?.action} ?`)
};

const de_seo_endpoint_q_failover = /** @type {(inputs: Seo_Endpoint_Q_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Was passiert, wenn bei der ${i?.name}-${i?.action}-API eine Quelle ausfällt?`)
};

const ru_seo_endpoint_q_failover = /** @type {(inputs: Seo_Endpoint_Q_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Что будет, если источник откажет в API ${i?.name} ${i?.action}?`)
};

const it_seo_endpoint_q_failover = /** @type {(inputs: Seo_Endpoint_Q_FailoverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cosa succede se una fonte fallisce sull'API ${i?.name} ${i?.action}?`)
};

/**
* | output |
* | --- |
* | "What happens if a source fails on the {name} {action} API?" |
*
* @param {Seo_Endpoint_Q_FailoverInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_q_failover = /** @type {((inputs: Seo_Endpoint_Q_FailoverInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Q_FailoverInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_q_failover(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_q_failover(inputs)
	if (locale === "es") return es_seo_endpoint_q_failover(inputs)
	if (locale === "fr") return fr_seo_endpoint_q_failover(inputs)
	if (locale === "de") return de_seo_endpoint_q_failover(inputs)
	if (locale === "ru") return ru_seo_endpoint_q_failover(inputs)
	if (locale === "it") return it_seo_endpoint_q_failover(inputs)
	return en_seo_endpoint_q_failover(inputs)
});